import React from 'react';
import '../styles/forms.css';
import {Col, FormGroup, Button} from 'reactstrap';

export default class FrmEncuestas extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
        this.grabaResp = this.grabaResp.bind(this);
        this.generaFilas = this.generaFilas.bind(this);
    }
    
    grabaResp(e){
        var elm = e.target, td = elm.parentElement,
            tr = td.parentElement, idP = tr.getAttribute('idpreg'),
            preg = tr.querySelector('.tdPreg'), lbl = document.getElementById('lbl_preg_enc'),
            idp = document.getElementById('lbl_id_preg_enc'), dv = document.getElementById('dv_record');
        lbl.innerText = preg.innerText;
        idp.innerText = idP;
        dv.classList.remove('Hide_All');
    }

    generaFilas(){
        return this.props.info.map((p, index)=>{
            return(
                <tr key={index} idpreg={p.IdEncuesta}>
                    <td className='tdPreg'>{p.pregunta}</td>
                    <td>{(p.pendiente ? 'Pendiente': 'Registrada')}</td>
                    <td><Button outline color='danger' className={'btn_rspst ' + (p.pendiente ? '': 'Hide_All')} onClick={(e)=> this.grabaResp(e)} >Grabar Respuesta</Button></td>
                </tr>
            );
        });
    }

    render() {
        return (
            <div className="APL_Frm_dv">
                <FormGroup id='dv_record' className='Hide_All' row>
                    <Col sm={12} md={12} lg={12} >
                        <label id='lbl_id_preg_enc'></label>
                        <label id='lbl_preg_enc'></label>
                    </Col>
                    <Col sm={12} md={12} lg={12} >
                        
                    </Col>
                    <Col sm={12} md={12} lg={12} >
                        <Button color='primary'>Envíar Respuesta</Button>
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Col sm={12} md={12} lg={12} >
                        <table className='tbl_encuesta'>
                            <thead>
                                <tr>
                                    <th>Pregunta</th>
                                    <th>Estatus</th>
                                    <th>Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.generaFilas()}
                            </tbody>
                        </table>
                    </Col>
                </FormGroup>
            </div>
        );
    }
}